import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import router from './router';

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "@fortawesome/fontawesome-free/css/all.css"
import '@/assets/style.css'

import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';

const pinia = createPinia()

const app = createApp(App)

app.component('QrcodeStream', QrcodeStream);
app.component('QrcodeDropZone', QrcodeDropZone);
app.component('QrcodeCapture', QrcodeCapture);

app.use(router)
app.use(pinia)
VueQueryPlugin.install( app, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        cacheTime: 1000*60, // 1 minuto
        refetchOnReconnect: 'always'
      }
    }
  }
})
app.mount('#app')